import { Pipe, PipeTransform } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';

/**
 * Angular pipe to check if domain uses selected guideline id
 */
@Pipe({
    name: 'accessibilityHasGuidelineId',
    pure: false,
    standalone: false,
})
export class AccessibilityHasGuidelineIdPipe implements PipeTransform {
    private readonly guidelines = {
        'QUALWEB-A': ['QUALWEB-A'],
        'QUALWEB-AA': ['QUALWEB-A', 'QUALWEB-AA'],
        'WCAG2-A': ['WCAG2-A'],
        'WCAG2-AA': ['WCAG2-A', 'WCAG2-AA'],
        'WCAG2-AAA': ['WCAG2-A', 'WCAG2-AA', 'WCAG2-AAA'],
        'WCAG21-A': ['WCAG21-A'],
        'WCAG21-AA': ['WCAG21-A', 'WCAG21-AA'],
        'WCAG21-AAA': ['WCAG21-A', 'WCAG21-AA', 'WCAG21-AAA'],
        'WCAG22-A': ['WCAG22-A'],
        'WCAG22-AA': ['WCAG22-A', 'WCAG22-AA'],
        'WCAG22-AAA': ['WCAG22-A', 'WCAG22-AA', 'WCAG22-AAA'],
        'WCAG21-A_mobile': ['WCAG21-A_MOBILE'],
        'WCAG21-AA_mobile': ['WCAG21-A_MOBILE', 'WCAG21-AA_MOBILE'],
        'WCAG21-AAA_mobile': ['WCAG21-A_MOBILE', 'WCAG21-AA_MOBILE', 'WCAG21-AAA_MOBILE'],
        'WCAG22-A_mobile': ['WCAG22-A_MOBILE'],
        'WCAG22-AA_mobile': ['WCAG22-A_MOBILE', 'WCAG22-AA_MOBILE'],
        'WCAG22-AAA_mobile': ['WCAG22-A_MOBILE', 'WCAG22-AA_MOBILE', 'WCAG22-AAA_MOBILE'],
    };

    constructor (private sessionService: SessionService) {}

    /**
     * Transform method to check if domain uses selected guideline id
     * @param guidelineId - The guideline ID to check
     * @param domain - Optional domain object, defaults to session domain
     * @returns Boolean indicating if the guideline ID is supported
     */
    transform (guidelineId: string, domain?: any): boolean {
        if (typeof guidelineId !== 'string') {
            return false;
        }

        const selectedDomain = domain || this.sessionService.domain;
        const normalizedGuidelineId = guidelineId.toUpperCase();

        if (selectedDomain === null || typeof selectedDomain === 'undefined') {
            return false;
        }

        if (typeof selectedDomain.features?.accessibility !== 'string') {
            return false;
        }

        let accessibility = selectedDomain.features.accessibility;

        const indexOfVersion = accessibility.search(/_v(\d+)?/);
        /* Makes accessibility guidelines independent of version for displaying */
        if (indexOfVersion > -1) {
            accessibility = accessibility.slice(0, indexOfVersion);
        }

        return this.guidelines[accessibility] && this.guidelines[accessibility].includes(normalizedGuidelineId);
    }
}
